import styled from "styled-components";
import { Box } from "@mui/material";
import { ReactNode } from "react";

type FormBorderProps = {
  children?: ReactNode;
};

const StyledBox = styled(Box)`
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  padding: 1.5rem 1rem;
  margin: 2rem 0 0 0;
`;

export const FormBorder = ({ children }: FormBorderProps) => <StyledBox>{children}</StyledBox>;
